<template>
  <div>
    <md-autocomplete
      id="customer-dropdown"
      md-dense
      v-model="selectedCustomer"
      :md-options="customers"
      @md-changed="getCustomers"
      @md-selected="customerSelected"
    >
      <template v-slot:md-autocomplete-item="{ item, term }">
        <md-highlight-text :md-term="term"
          >{{ item.full_name }} ({{ item.email }})</md-highlight-text
        >
      </template>
    </md-autocomplete>
  </div>
</template>

<script>
import customerApi from "@/services/api/customer";
import _debounce from "lodash/debounce";

export default {
  props: {
    value: {
      type: null,
      default: null
    }
  },

  data() {
    return {
      customers: [],
      selectedCustomer: ""
    };
  },

  methods: {
    customerSelected(customer) {
      this.selectedCustomer = customer.full_name;
      this.$emit("input", customer.id);
    },

    getCustomers: _debounce(function(searchTerm) {
      this.customers = new Promise(resolve => {
        if (!searchTerm) {
          resolve([]);
        } else {
          customerApi.findCustomer(searchTerm).then(resp => {
            resolve(
              resp.data.customers.map(customer => ({
                ...customer,
                toString: () => customer.full_name
              }))
            );
          });
        }
      });
    }, 500)
  }
};
</script>

<style lang="scss" scoped>
#customer-dropdown {
  &::v-deep .md-menu-content {
    z-index: 999 !important;
  }
}
</style>

<style lang="scss">
.md-menu-content {
  z-index: 999 !important;
}

.md-list.md-theme-default .md-autocomplete-items .md-highlight-text-match {
  color: red;
  padding: 0 !important;
}
</style>
